import { queryOptions } from "@tanstack/react-query"
import { request } from "@utils/request"

export const listQuery = queryOptions({
  queryKey: ["dovetail", "conversations", "list"],
  queryFn: () =>
    request
      .post("api/dt/conversations/list", {
        json: {
          from: new Date("2026-08-15T00:00:00Z"),
          to: new Date(),
        },
      })
      .json<{ conversations: unknown[]; continuationToken: null | string }>(),
})
